import i18next from "i18next"

const thousandSeparator = (number, unit = "تومان") => {
  const n = Number(number || 0)

  const unitText =  i18next.t(unit)

  const x = Math.round(Math.abs(n) * 100) / 100

  const string =
    String(x | 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${string}${n >= 0 ? "" : "-"} ${unitText}`
}

export default thousandSeparator